import React from 'react'

const SpareSalesTableCard = ({ title, children }) => {
  return (
    <div className="rounded-t-md">
      <p className='bg-[#2374BF] py-1 px-2 text-white font-semibold text-md rounded-t-md'>{title}</p>
      <div>
        {children}
      </div>
    </div>
  )
}

export default SpareSalesTableCard